import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import {
  showCustomToast,
  CustomToastContainer,
} from "../../components/CustomToast";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { AiFillHome, AiOutlineAppstore } from "react-icons/ai";
import { Link } from "react-router-dom";
import LoginModal from "../../components/LoginModel"; // Import the modal
import { useAuth } from "../../context/auth"; // Import the useAuth hook
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
import { AiOutlineLoading } from "react-icons/ai";
import TermsModal from "../../components/TermsModal.jsx";

const FullScreenLoader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="text-center">
        <AiOutlineLoading
          className="mx-auto mb-4 text-white animate-spin"
          size={64}
        />
        <p className="text-white text-xl font-semibold">
          Processing your application...
        </p>
        <p className="text-white text-sm mt-2">
          Please do not close the window
        </p>
      </div>
    </div>
  );
};

const Kisan_point = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [auth] = useAuth(); // Access auth state from context
  const isLoggedIn = Boolean(auth.token); // Determine if user is logged in based on token
  const [formPrices, setFormPrices] = useState({}); // State for form prices
  const [selectedPrice, setSelectedPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // New loading state
  const [txn_id, setTxnId] = useState(null);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isTermsActive, setIsTermsActive] = useState(false);
  const [wasTermsModalOpened, setWasTermsModalOpened] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    // Show the modal if the user is not logged in
    if (!isLoggedIn) {
      setIsModalOpen(true); // Show the modal if not logged in
    }
  }, [isLoggedIn]); // Run effect whenever isLoggedIn changes

  const closeModal = () => {
    setIsModalOpen(false); // Function to close modal
  };

  // Function to open terms modal
  const openTermsModal = (e) => {
    e.preventDefault();
    setIsTermsModalOpen(true);
  };
  // Function to track when the modal is opened
  const handleTermsModalOpen = () => {
    setWasTermsModalOpened(true);
  };
  // Set isChecked to isTermsActive when terms are accepted
  useEffect(() => {
    if (isTermsActive) {
      setIsChecked(true);
    }
  }, [isTermsActive]);
  useEffect(() => {
    // Fetch form prices from the backend
    const fetchFormPrices = async () => {
      try {
        const response = await axios.get(
          "https://api.makeeasydocuments.com/api/formprices/getallformprice"
        );
        const prices = response.data.reduce((acc, formPrice) => {
          acc[formPrice.formType] = formPrice.price;
          return acc;
        }, {});
        setFormPrices(prices);
        setSelectedPrice(
          prices["8auttra"] ||
            prices["digital7/12"] ||
            prices["pickvima"] ||
            prices["fairfar"] ||
            prices["pmkisannidhiyojana"] ||
            0
        ); // Default price for foodLicenseYear1
        console.log("form price", selectedPrice);
      } catch (error) {
        console.error("Error fetching form prices:", error);
        showCustomToast("Error fetching form prices.", "error");
      }
    };
    fetchFormPrices();
  }, []);

  // Define the initial form data
  const initialFormData = {
    application_type: "Kisan Point ",
    kisanpointtype: "",
    fullName: "",
    email: "",
    address: "",
    state: "",
    pincode: "",
    mobileNumber: "",
    dateOfBirth: "",
    gatNumber: "",
    khatanumber: "",
    district: "",
    tehsil: "",
    village: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [transactionID, setTransactionID] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
      application_type:
        name === "kisanpointtype" ? `${value}` : prevData.application_type,
    }));

    if (name === "kisanpointtype") {
      // Change to check for 'vehicleType'
      if (value === "Digital 7 / 12") {
        setSelectedPrice(formPrices["digital7/12"] || 0);
      } else if (value === "8 अ उत्तरा") {
        setSelectedPrice(formPrices["8auttra"] || 0);
      } else if (value === "पिक विमा") {
        setSelectedPrice(formPrices["pickvima"] || 0);
      } else if (value === "Fair Far") {
        setSelectedPrice(formPrices["Fair_Far"] || 0);
      } else if (value === "PM Kisan Nidhi Yojana") {
        setSelectedPrice(formPrices["PM_Kisan_Nidhiyojana"] || 0);
      }
    }
  };

  const generateTransactionID = () => {
    const timeStamp = Date.now();
    const randomNum = Math.floor(Math.random() * 1000000);
    const merchantPrefix = "T";
    const transactionID = `${merchantPrefix}${timeStamp}${randomNum} `;
    // console.log("transaction in generated", transactionID)
    setTransactionID(transactionID);
    // return transactionID;
  };

  useEffect(() => {
    generateTransactionID();
  }, []); // Add dependency array to prevent infinite loop

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Check if the terms modal was opened
    if (!wasTermsModalOpened) {
      alert("Please open the terms and conditions modal before submitting.");
      setIsLoading(false); // Stop loading if condition is not met
      return; // Stop further execution
    }

    // Check if the terms and conditions checkbox is checked
    if (!isChecked) {
      alert("Please agree to the terms and conditions by checking the box.");
      setIsLoading(false); // Stop loading if condition is not met
      return; // Stop further execution
    }

    // Check if user is authenticated
    if (!auth.token) {
      showCustomToast("Please log in to fill out the form.", "error");
      return;
    }
    setIsLoading(true);

    try {
      // Create the form data object with all fields including transactionID
      const submissionData = {
        ...formData,
        transactionId: transactionID,
      };

      // Set up headers for the request
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`, // Include the token in the header if needed
        },
      };
      const response = await axios.post(
        "https://api.makeeasydocuments.com/api/commonForm/createcommon-form",
        submissionData,
        config // Include the config object
      );

      let formID;
      let userId;
      if (
        response.data &&
        response.data.newCommonForm &&
        response.data.newCommonForm._id
      ) {
        // Extract the form ID from the response
        formID = response.data.newCommonForm._id;
        userId = response.data.newCommonForm.user;
        console.log("Form ID:", formID);
      } else {
        console.error("Unexpected response format:", response.data);
      }

      // Proceed with the PayU payment logic after form submission
      const payuResponse = await axios.post(
        "https://api.makeeasydocuments.com/api/payu/hash",
        {
          formId: formID, // 👈 Add this line to send formId
          formType: formData.kisanpointtype,
          fullName: formData.fullName,
          email: formData.email,
          amount: selectedPrice,
          transactionId: transactionID,
          udf1: "detail 1",
          udf2: "detail 2",
          udf3: "",
          udf4: "",
          udf5: "",
        }
      );

      const { hash } = payuResponse.data;

      const payuForm = document.createElement("form");
      payuForm.action = "https://api.makeeasydocuments.com/get-payment";
      payuForm.method = "POST";

      const fields = {
        userId: userId,
        formId: formID,
        formType: formData.kisanpointtype,
        key: "nC1EmY",
        txnid: transactionID,
        amount: selectedPrice,
        productinfo: formData.kisanpointtype,
        firstname: formData.fullName,
        email: formData.email,
        phone: formData.mobileNumber,
        surl: `https://makeeasydocuments.com/success_payment?txnid=${txn_id}`, // Frontend success page
        furl: `https://makeeasydocuments.com/payment-failed`, // Frontend failure page
        hash: hash,
        udf1: "detail 1",
        udf2: "detail 2",
        udf3: "",
        udf4: "",
        udf5: "",
      };

      for (const key in fields) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = fields[key];
        payuForm.appendChild(input);
      }

      document.body.appendChild(payuForm);
      payuForm.submit();
      console.log(response.data); // Handle the response as needed

      // Reset the form fields to their initial state after successful submission
      setFormData(initialFormData);
    } catch (error) {
      showCustomToast("Error submitting the form. Please try again.", "error");
      console.error(error.response ? error.response.data : error); // Handle the error as needed
    } finally {
      setIsLoading(false); // Stop the loading spinner in both success and error cases
    }
  };

  return (
    <div>
      {isLoading && <FullScreenLoader />}

      <Header />
      <div className="page-title py-6 bg-slate-300" data-aos="fade">
        <div className="container mx-auto px-4 lg:px-20 flex flex-col lg:flex-row justify-between items-start lg:items-center">
          <h1 className=" text-black text-xl md:text-2xl font-semibold">
            Kisan Point{" "}
          </h1>

          <style jsx>{`
            @keyframes intenseBlink {
              0%,
              100% {
                opacity: 1;
                color: #f20000;
              }
              20% {
                opacity: 1;
                color: #000000;
              }
            }
          `}</style>
          <h1 className="text-lg md:text-xl font-bold underline underline-offset-8 mb-2 lg:mb-0 lg:ml-4 animate-[intenseBlink_1s_ease-in-out_infinite]">
            100% Fees Refundable, if Service is not Completed!
          </h1>

          <nav className="breadcrumbs mt-2 lg:mt-0">
            <ol className="flex space-x-2 lg:space-x-4 text-sm items-center">
              <li className="flex items-center">
                <AiFillHome className="mr-1 text-base hover:underline" />
                <Link to={"/"} className="text-black hover:underline text-base">
                  Home
                </Link>
              </li>
              <li className="text-black">/</li>
              <li className="flex items-center">
                <AiOutlineAppstore className="mr-1 text-base" />
                <Link
                  to={"/all_service"}
                  className="text-black hover:underline text-base"
                >
                  All Services
                </Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <div className="container mx-auto px-4 lg:px-16 py-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold border-b-4 border-red-600 inline-block pb-2">
            Kisan Point
          </h2>
        </div>
        <hr className="h-px my-9 bg-gray-700 border-none dark:bg-gray-700" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left side - Form */}
          <div className="bg-white p-10 rounded-lg shadow-xl">
            <form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols- gap-4 mb-4">
                <h2 className="text-green-600 font-semibold text-xl text-center sm:text-left">
                  Service Charge :{" "}
                  <span className="text-red-600" id="formprice">
                    {" "}
                    ₹ {selectedPrice}
                  </span>
                </h2>
                <div>
                  <label className="block text-sm font-semibold mb-2">
                    Kissan Point Type
                  </label>
                  <select
                    name="kisanpointtype"
                    value={formData.kisanpointtype}
                    onChange={handleInputChange}
                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                    required
                  >
                    <option value="">-- Select Kissan Point Type --</option>
                    <option value="Digital 7 / 12">Digital 7 / 12</option>
                    <option value="8 अ उत्तरा">8 अ उत्तरा</option>
                    <option value="Fair Far">Fair Far</option>
                    <option value="PM Kisan Nidhi Yojana">
                      PM Kisan Nidhi Yojana
                    </option>
                    <option value="पिक विमा">पिक विमा</option>
                  </select>
                </div>
              </div>

              {/* Conditionally render based on Kissan Point Type */}
              {formData.kisanpointtype === "Digital 7 / 12" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Survey / गट Number
                    </label>
                    <input
                      type="text"
                      name="gatNumber"
                      value={formData.gatNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Surve / Gat Number"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="Enter Full Name"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      District
                    </label>
                    <input
                      type="text"
                      name="district"
                      value={formData.district}
                      onChange={handleInputChange}
                      placeholder="Enter District"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Tehsil
                    </label>
                    <input
                      type="text"
                      name="tehsil"
                      value={formData.tehsil}
                      onChange={handleInputChange}
                      placeholder="Enter tehsil"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Village
                    </label>
                    <input
                      type="text"
                      name="village"
                      value={formData.village}
                      onChange={handleInputChange}
                      placeholder="Enter Village"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Mobile Number"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      } // Only allows digits
                      pattern="[0-9]{10}"
                      maxLength="10"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="example@gmail.com" // Placeholder for guidance
                      className={`w-full border ${
                        formData.email && !formData.email.includes("@")
                          ? "border-red-500"
                          : "border-gray-300"
                      } rounded px-3 py-2 focus:outline-none`}
                      required
                      pattern="[a-zA-Z0-9._%+-]+@gmail\.com" // Regex pattern for Gmail addresses
                      title="Please enter a valid Gmail address." // Error message for invalid input
                      onBlur={(e) => {
                        // Validate on input blur
                        if (!e.target.value.includes("@")) {
                          e.target.setCustomValidity(
                            'You must include "@" in your email.'
                          );
                        } else {
                          e.target.setCustomValidity(""); // Clear the error
                        }
                      }}
                    />
                    {formData.email && !formData.email.includes("@") && (
                      <span className="text-red-500 text-xs mt-1">
                        Email must contain "@"
                      </span>
                    )}
                  </div>
                </div>
              )}

              {formData.kisanpointtype === "8 अ उत्तरा" && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Khata ( खाता ) Number
                    </label>
                    <input
                      type="text"
                      name="khatanumber"
                      value={formData.khatanumber}
                      onChange={handleInputChange}
                      placeholder="Enter Khata Number"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="Enter Full Name"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      District
                    </label>
                    <input
                      type="text"
                      name="district"
                      value={formData.district}
                      onChange={handleInputChange}
                      placeholder="Enter District"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Tehsil
                    </label>
                    <input
                      type="text"
                      name="tehsil"
                      value={formData.tehsil}
                      onChange={handleInputChange}
                      placeholder="Enter Tehsil"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Village
                    </label>
                    <input
                      type="text"
                      name="village"
                      value={formData.village}
                      onChange={handleInputChange}
                      placeholder="Enter Village"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Mobile Number"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      } // Only allows digits
                      pattern="[0-9]{10}"
                      maxLength="10"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="example@gmail.com" // Placeholder for guidance
                      className={`w-full border ${
                        formData.email && !formData.email.includes("@")
                          ? "border-red-500"
                          : "border-gray-300"
                      } rounded px-3 py-2 focus:outline-none`}
                      required
                      pattern="[a-zA-Z0-9._%+-]+@gmail\.com" // Regex pattern for Gmail addresses
                      title="Please enter a valid Gmail address." // Error message for invalid input
                      onBlur={(e) => {
                        // Validate on input blur
                        if (!e.target.value.includes("@")) {
                          e.target.setCustomValidity(
                            'You must include "@" in your email.'
                          );
                        } else {
                          e.target.setCustomValidity(""); // Clear the error
                        }
                      }}
                    />
                    {formData.email && !formData.email.includes("@") && (
                      <span className="text-red-500 text-xs mt-1">
                        Email must contain "@"
                      </span>
                    )}
                  </div>
                </div>
              )}

              {/* Render default fields when no type or other types are selected */}
              {(!formData.kisanpointtype ||
                (formData.kisanpointtype !== "Digital 7 / 12" &&
                  formData.kisanpointtype !== "8 अ उत्तरा")) && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="Enter Full Name"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Your Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="example@gmail.com" // Placeholder for guidance
                      className={`w-full border ${
                        formData.email && !formData.email.includes("@")
                          ? "border-red-500"
                          : "border-gray-300"
                      } rounded px-3 py-2 focus:outline-none`}
                      required
                      pattern="[a-zA-Z0-9._%+-]+@gmail\.com" // Regex pattern for Gmail addresses
                      title="Please enter a valid Gmail address." // Error message for invalid input
                      onBlur={(e) => {
                        // Validate on input blur
                        if (!e.target.value.includes("@")) {
                          e.target.setCustomValidity(
                            'You must include "@" in your email.'
                          );
                        } else {
                          e.target.setCustomValidity(""); // Clear the error
                        }
                      }}
                    />
                    {formData.email && !formData.email.includes("@") && (
                      <span className="text-red-500 text-xs mt-1">
                        Email must contain "@"
                      </span>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Address
                    </label>
                    <input
                      type="text"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      placeholder="Enter Address"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Pincode
                    </label>
                    <input
                      type="text"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleInputChange}
                      placeholder="Enter Pincode"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      pattern="\d{6}" // Require exactly 6 digits
                      maxLength="6"
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 6);
                      }}
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Mobile Number
                    </label>
                    <input
                      type="text"
                      name="mobileNumber"
                      value={formData.mobileNumber}
                      onChange={handleInputChange}
                      placeholder="Enter Mobile Number"
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      onInput={(e) =>
                        (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                      } // Only allows digits
                      pattern="[0-9]{10}"
                      maxLength="10"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold mb-2">
                      Date of Birth
                    </label>
                    <input
                      type="date"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none"
                      required
                    />
                  </div>
                  <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              className="w-4 h-4"
              required
              checked={isChecked}
              onChange={(e) => {
                if (wasTermsModalOpened) {
                  setIsChecked(e.target.checked);
                } else {
                  alert(
                    "Please open the terms and conditions modal before checking the box."
                  );
                }
              }}
            />
            <span>
              {" "}
              I agree to submit this form and accept the{" "}
              <a
                href="#"
                onClick={openTermsModal}
                className="text-blue-600 underline"
              >
                <br/>
                terms & conditions
              </a>
              .
            </span>
          </label>

   {/* Terms Modal Component with tracking callback */}
   <TermsModal
            isOpen={isTermsModalOpen}
            setIsOpen={setIsTermsModalOpen}
            setIsTermsActive={setIsTermsActive}
            onModalOpen={handleTermsModalOpen}
          />    

                </div>
              )}

              <div className="text-center mt-6">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`
                            bg-green-600 text-white py-2 px-4 rounded 
                            ${
                              isLoading
                                ? "opacity-50 cursor-not-allowed"
                                : "hover:bg-green-700"
                            }
                            flex items-center justify-center mx-auto
                        `}
                >
                  {isLoading ? (
                    <>
                      <AiOutlineLoading className="mr-2 animate-spin" />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Right side - Content */}
          <div className="bg-slate-200 p-3">
            <h1 className="font-semibold text-2xl">Make Easy Agro Market :</h1>{" "}
            <br />
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <h3 className="text-xl font-semibold text-orange-600 mb-2 text-center">
                Your Kisan Point for Farm Fresh Solutions!
              </h3>
              <h3 className="text-lg font-semibold text-green-600 mb-2 text-center">
                * Do Enquiry For Apply : -
              </h3>

              <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 list-inside text-gray-600 mt-2">
                <li>✔ Digital 7 / 12</li>
                <li>✔ Fair Far</li>
                <li>✔ 8 अ उत्तरा</li>
                <li>✔ PM kisan Nidhi Yojana</li>
                <li>✔ पिक विमा</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* Render Login Modal only if not logged in */}
      {!isLoggedIn && isModalOpen && <LoginModal closeModal={closeModal} />}
      <CustomToastContainer />
      <Footer />
    </div>
  );
};

export default Kisan_point;
